// extracted by mini-css-extract-plugin
export var infoItem = "_u5-2";
export var title = "_u5-0";
export var value = "_u5-1";